import { ReactElement } from 'react';

import { AchievementFormValues } from 'types';

import { AchievementForm } from '../AchievementForm';
import { useCreateAchievementForm } from './hooks';

interface CreateAchievementFormProps {
  defaultValues: AchievementFormValues;
  employeeId?: string;
  onClose?: () => void;
}

export function CreateAchievementForm({
  defaultValues,
  employeeId,
  onClose,
}: CreateAchievementFormProps): ReactElement {
  const { handleSubmit, isLoading } = useCreateAchievementForm({ employeeId, onClose });

  return (
    <AchievementForm
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}
